import React, { useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useFlavour } from '../../context/FlavourContext';
import { QUIZ, FLAVOURS } from '../../data/mock';
import ProductBox from '../../components/ProductBox';
import FlavourCTA from '../../components/FlavourCTA';
import Reveal from '../../components/Reveal';
import { track } from '../../lib/analytics';

export default function Quiz() {
  const { setFlavour } = useFlavour();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [scores, setScores] = useState({});
  const [result, setResult] = useState(null);

  const start = () => { setStep(0); setScores({}); setResult(null); track('quiz_started', {}); };

  const answer = (flavourId) => {
    const next = { ...scores, [flavourId]: (scores[flavourId] || 0) + 1 };
    setScores(next);
    if (step < QUIZ.length - 1) {
      setStep(step + 1);
    } else {
      const best = Object.entries(next).sort((a, b) => b[1] - a[1])[0][0];
      setResult(best);
      setFlavour(best, 'quiz');
      track('quiz_completed', { flavour: best });
    }
  };

  const rf = result ? FLAVOURS[result] : null;

  return (
    <section className="py-20 md:py-28">
      <div className="max-w-[1100px] mx-auto px-5">
        <Reveal className="text-center mb-10">
          <p className="font-cond tracking-[0.3em] text-white/40 text-sm">FLAVOUR QUIZ</p>
          <h2 className="font-display text-4xl md:text-6xl mt-2">WHICH S-MAN <span className="text-flavour flavour-transition">ARE YOU?</span></h2>
        </Reveal>

        <div className="rounded-3xl border border-white/10 bg-[#0b0b0b] p-6 md:p-10 min-h-[340px] flex flex-col justify-center">
          {!result ? (
            <div>
              <div className="flex items-center justify-between mb-6">
                <span className="font-cond tracking-wide text-white/40 text-sm">{step + 1} / {QUIZ.length}</span>
                <div className="flex gap-1.5">
                  {QUIZ.map((_, i) => (<span key={i} className="h-1.5 rounded-full transition-all" style={{ width: i === step ? 28 : 12, background: i <= step ? 'var(--flavour-primary)' : 'rgba(255,255,255,0.15)' }} />))}
                </div>
              </div>
              <h3 className="font-display text-2xl md:text-3xl mb-6">{QUIZ[step].q}</h3>
              <div className="grid sm:grid-cols-2 gap-3">
                {QUIZ[step].a.map((opt) => (
                  <button key={opt.label} onClick={() => answer(opt.flavour)}
                    className="text-left px-5 py-4 rounded-xl border border-white/10 bg-white/[0.02] hover:border-flavour hover:bg-white/[0.05] transition-all font-cond tracking-wide text-lg">
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col md:flex-row items-center gap-8 justify-center">
              <ProductBox flavourId={result} size="md" />
              <div className="text-center md:text-left">
                <p className="font-cond tracking-[0.25em] text-white/50">YOUR S-MAN IS...</p>
                <h3 className="font-display text-5xl md:text-6xl my-2" style={{ color: rf.primary }}>{rf.name}</h3>
                <p className="text-white/60 max-w-xs mb-6">{rf.personality}</p>
                <div className="flex flex-col sm:flex-row gap-3 items-center justify-center md:justify-start">
                  <FlavourCTA onClick={() => navigate('/flavours')} />
                  <button onClick={start} className="inline-flex items-center gap-2 text-white/60 hover:text-white font-cond tracking-wide text-sm"><RotateCcw className="w-4 h-4" /> TAKE THE QUIZ AGAIN</button>
                </div>
                <p className="text-xs text-white/30 mt-4">This recommends a flavour personality only. All flavours share the same formula.</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
